export default __webpack_public_path__ + "static/media/italic.9b71af05.svg";